import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './collapsible-row.magic.css.js';
import CollapsibleRowComponent from './collapsible-row.js';

const __vue_script__ = CollapsibleRowComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ul",
    {
      staticClass: "list",
      class: [
        {
          "list--left": _vm.left,
          "list--right": _vm.right
        }
      ],
      style: {
        "--magic-collapsible-row-used-width": _vm.usedWidth
      },
      attrs: {
        part: _vm.$p("list", [
          {
            "list--left": _vm.left,
            "list--right": _vm.right
          }
        ])
      }
    },
    _vm._l(_vm.items, function(item, index) {
      return _c(
        "li",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hiddenIndexes.includes(index),
              expression: "!hiddenIndexes.includes(index)"
            }
          ],
          key: item.name + index,
          ref: "item",
          refInFor: true,
          staticClass: "item",
          attrs: { part: "item" }
        },
        [
          item.link
            ? _c(
                "magic-router-link",
                {
                  staticClass: "link",
                  class: { "is-active": _vm.activeItem === item.slug },
                  attrs: {
                    part: _vm.$p("link", {
                      "is-active": _vm.activeItem === item.slug
                    }),
                    to: item.link
                  }
                },
                [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
              )
            : _c(
                "span",
                {
                  staticClass: "text",
                  class: { "is-active": _vm.activeItem === item.slug },
                  attrs: {
                    part: _vm.$p("text", {
                      "is-active": _vm.activeItem === item.slug
                    })
                  },
                  on: {
                    click: function($event) {
                      return _vm.onItemClick(item.slug)
                    }
                  }
                },
                [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
              )
        ],
        1
      )
    }),
    0
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-389b567c_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-389b567c";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
